import moment from 'moment-jalaali';

export function toShamsi(year: number, month: number, day: number): string {
    const g_days_in_month = [31, 28 + (isLeapYear(year) ? 1 : 0), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    const g_day_of_year = g_days_in_month.slice(0, month - 1).reduce((a, b) => a + b, 0) + day;

    let jy = year - 621;
    let jm = 0;
    let jd = g_day_of_year;

    if (g_day_of_year > 79) {
        jd -= 79;
    } else {
        jy--;
        jd += 10;
    }

    const j_days_in_month = [31, 30, 31, 31, 30, 30, 31, 31, 30, 30, 30, 29];

    for (let i = 0; i < j_days_in_month.length; i++) {
        if (jd <= j_days_in_month[i]) {
            jm = i + 1;
            break;
        }
        jd -= j_days_in_month[i];
    }

    return `${jd} ${getPersianMonth(jm)}`;
}

function isLeapYear(year: number): boolean {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}

function getPersianMonth(month: number): string {
    const persianMonths = [
        "فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور",
        "مهر", "آبان", "آذر", "دی", "بهمن", "اسفند"
    ];
    return persianMonths[month - 1];
}


export function toShamsiDate(date: string): string {
    const shamsiDate = moment(date, 'YYYY-MM-DD').format('jYYYY-jMM-jDD');
    return shamsiDate;
}